import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ProductHero from './components/ProductHero';
import Features from './components/Features';
import ProductGrid from './components/ProductGrid';
import Installation from './components/Installation';
import SEOHead from '@/components/feature/SEOHead';

export default function PompesChaleur() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Pompe à Chaleur Neuenegg ELCO - Installation PAC Air-Eau - CasaReNovaPlus",
    "provider": {
      "@type": "LocalBusiness",
      "name": "CasaReNovaPlus",
      "telephone": "+41797616282",
      "address": { "@type": "PostalAddress", "streetAddress": "Austrasse 95", "addressLocality": "Neuenegg", "addressRegion": "Fribourg", "postalCode": "3176", "addressCountry": "CH" },
      "geo": { "@type": "GeoCoordinates", "latitude": "46.233333", "longitude": "6.083333" },
      "openingHoursSpecification": [
        { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "19:00" },
        { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }
      ],
      "priceRange": "CHF"
    },
    "areaServed": ["Genève", "Meyrin", "Carouge", "Lancy", "Vernier", "Onex", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
    "description": "Installation pompe à chaleur ELCO à Genève. PAC air-eau, géothermique, subventions cantonales jusqu'à CHF 10'000. COP 5.2, A+++. Techniciens certifiés.",
    "serviceType": "Installation pompe à chaleur PAC air-eau géothermique",
    "offers": { "@type": "Offer", "availability": "https://schema.org/InStock", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "CHF", "description": "Devis gratuit + étude thermique" } },
    "url": `${import.meta.env.VITE_SITE_URL}/pompes-chaleur`
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Pompe à Chaleur Neuenegg ELCO | PAC Air-Eau Subvention CHF 10'000 - CasaReNovaPlus"
        description="Installation pompe à chaleur ELCO à Genève. PAC air-eau et géothermique, COP 5.2, A+++. Subventions cantonales jusqu'à CHF 10'000. Économisez 75% sur chauffage. Techniciens certifiés. Devis gratuit."
        keywords="pompe à chaleur Genève, PAC air-eau Genève, installation pompe chaleur Genève, ELCO Genève, subvention pompe chaleur Genève, chauffage écologique Genève, géothermique Genève, remplacement chaudière Genève, chauffage au sol Genève, PAC Meyrin Carouge Lancy, économie chauffage Genève, transition énergétique Genève"
        canonical={`${import.meta.env.VITE_SITE_URL}/pompes-chaleur`}
        schema={schema}
      />
      <Header />
      <ProductHero />
      <Features />
      <ProductGrid />
      <Installation />
      <ExpertiseSection />
      <Footer />
    </div>
  );
}

function ExpertiseSection() {
  return (
    <section id="expertise" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Notre Expertise</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Des Professionnels Certifiés à Votre Service
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600 max-w-3xl mx-auto">
            Plus de 19 ans d'expérience dans l'installation et la maintenance de pompes à chaleur en Suisse. Notre équipe d'experts certifiés garantit des installations conformes aux normes suisses les plus strictes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Certifications Suisses</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Tous nos techniciens sont certifiés et régulièrement formés aux dernières technologies de pompes à chaleur. Nous respectons scrupuleusement les normes SIA et les réglementations cantonales genevoises.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Certification F-Gaz obligatoire
              </li>
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Formation continue annuelle
              </li>
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Partenaires agréés des marques
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
              <i className="ri-tools-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Équipements Professionnels</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Nous utilisons uniquement des équipements de diagnostic et d'installation de dernière génération pour garantir la qualité et la performance optimale de votre installation.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Analyseurs thermiques professionnels
              </li>
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Outils de mesure calibrés
              </li>
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Matériel de sécurité certifié
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
              <i className="ri-customer-service-2-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Service Client Premium</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Un accompagnement personnalisé de A à Z : étude thermique gratuite, conseils sur les subventions cantonales, installation clé en main et service après-vente réactif.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Réponse sous 24h ouvrées
              </li>
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Intervention d'urgence 24/7
              </li>
              <li className="flex items-center text-sm text-gray-700">
                <i className="ri-check-line text-teal-600 mr-2"></i>
                Garantie étendue disponible
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
              <i className="ri-line-chart-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Optimisation Énergétique</h3>
            <p className="text-gray-600 leading-relaxed">
              Nous réalisons une étude thermique complète de votre bâtiment pour dimensionner parfaitement votre pompe à chaleur et maximiser vos économies d'énergie. Nos installations permettent jusqu'à 75% d'économies sur vos factures de chauffage.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
              <i className="ri-hand-coin-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Aide aux Subventions</h3>
            <p className="text-gray-600 leading-relaxed">
              Nous vous accompagnons dans vos démarches pour obtenir les subventions cantonales et fédérales. Le canton de Genève offre des aides pouvant couvrir jusqu'à 40% du coût de votre installation de pompe à chaleur.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
              <i className="ri-leaf-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Engagement Écologique</h3>
            <p className="text-gray-600 leading-relaxed">
              Nos solutions de pompes à chaleur utilisent des énergies renouvelables et des fluides frigorigènes à faible impact environnemental. Contribuez activement à la transition énergétique suisse tout en réduisant votre empreinte carbone.
            </p>
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Plus de 500 Installations Réussies en Suisse Romande
          </h3>
          <p className="text-teal-50 text-lg mb-8 max-w-2xl mx-auto">
            Rejoignez nos clients satisfaits qui ont fait confiance à notre expertise pour leur projet de pompe à chaleur. Demandez votre devis gratuit dès aujourd'hui.
          </p>
          <a
            href="#contact"
            className="inline-block bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
          >
            Demander un Devis Gratuit
          </a>
        </div>
      </div>
    </section>
  );
}
